import { render, staticRenderFns } from "./TenderContactPerson.vue?vue&type=template&id=8d68e4d2"
import script from "./TenderContactPerson.vue?vue&type=script&lang=js"
export * from "./TenderContactPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports